/* eslint-disable @next/next/no-img-element */
import { useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import http from 'utilities/http';
import { getCookie } from 'framework/libs/cookie';
import { TOKEN_CONGDONG } from 'framework/store/constants';
import { toast } from 'react-toastify';
import ProductSearch from 'components/cong-dong/tao-bai-viet/product-search';
import ProductDetail from 'components/cong-dong/tao-bai-viet/product-detail';
import Tag from "components/cong-dong/tao-bai-viet/image-tag";
import TagImage from "components/cong-dong/chi-tiet/image-tag";
import { useCart } from "framework/store";
import { isEmpty } from 'lodash';
import {IMG_URL, API_URL_V2} from "utilities/constants";
import { serialize } from 'object-to-formdata';
import { formatSku, getUrlName } from 'utilities/helper';

export default function EditorComponent({ displayModalTag, setDisplayModalTag, imageTag: imageTagP, setImage }) {
    const [stateStore, actions] = useCart();

    const [imageTag, setImageTag] = useState(imageTagP);
    const [taggedProduct, settaggedProduct] = useState([]);
    const [location, setLocation] = useState({top: '50%', left: '50%'});
    const [tagShowingId, setTagShowingId] = useState(null);

    useEffect(() => {
        setImageTag(imageTagP);
    }, [imageTagP]);

    const imgElement = useRef(null);
    const clickTag = (e) => {
        const topMouse = e.nativeEvent.offsetY;
        const leftMouse = e.nativeEvent.offsetX;
        const height = imgElement.current.clientHeight;
        const width = imgElement.current.clientWidth;
        setLocation({
            top: topMouse/height * 100 + '%',
            left: leftMouse/width * 100 + '%'
        });
    };

    const assignTag = (item) => {
        if (location.top == null) {
            toast.info('Hãy chọn vị trí trước khi tag sản phẩm.');
            return;
        }
        settaggedProduct(taggedProduct.concat({
            product: item,
            location: location
        }));
        setLocation({top: null, left: null});
    };

    const removeTag = (item) => {
        settaggedProduct(taggedProduct.filter(tagged => tagged.product.sku != item.sku));
    };

    const fetchMyImageById = async (id) => {
        const res = await http(`community/my-files?id=${id}`, {}, { token: 'Bearer ' + getCookie(TOKEN_CONGDONG) }, 'v2');
        if (res.success == true && !isEmpty(res.data)) {
            setImage(res.data[0]);
        }
    };

    const submitTag = async () => {
        if (isEmpty(taggedProduct)) {
            toast.error('Bạn cần tag ít nhất 1 sản phẩm');
            return;
        }
        const data = {
            'file_id': imageTag.id,
            products: taggedProduct.map(x => {
                let imgUrl = '/images/icon-app.svg';
                let vendor_id = 0;
                let vendor_name = '';
                let minimalPrice = 0;
                let urlKey = '';
                if (x.product.custom_attributes) {
                    const atributeImgUrl = x.product.custom_attributes.find(f => f.attribute_code == 'image');
                    imgUrl = atributeImgUrl ? IMG_URL + atributeImgUrl.value : '/images/icon-app.svg';

                    const atributeVendor = x.product.custom_attributes.find(f => f.attribute_code == 'vendor_id');
                    vendor_id = atributeVendor ? atributeVendor.value : 0;

                    const atributeMinimalPrice = x.product.custom_attributes.find(f => f.attribute_code == 'minimal_price');
                    minimalPrice = atributeMinimalPrice?.value || 0;

                    const url_key = x.product.custom_attributes.find(f => f.attribute_code == 'url_key');
                    urlKey = url_key?.value || '';
                }
                if (x.product.image) {
                    imgUrl = item.image;
                }
                const vendor = stateStore.vendorList?.find(k => k.id == vendor_id) || {};
                vendor_name = vendor.company || vendor.shop_name || vendor.name || '';
                return {
                    position: [x.location.left.substring(0, x.location.left.length - 1), x.location.top.substring(0, x.location.top.length - 1)],
                    product_id: x.product.sku,
                    product_name: x.product.name || x.product.title,
                    product_price: x.product.price || minimalPrice,
                    product_image: imgUrl,
                    product_url: urlKey ? `/shop/${formatSku(x.product.sku)}/${urlKey}.html` : `/shop/${formatSku(x.product.sku)}/${getUrlName(x.product.name || x.product.title)}.html`,
                    vendor_id: vendor_id,
                    vendor_name: vendor_name,
                };
            })
        };
        const res = await fetch(API_URL_V2 + 'community/photo/product-images/tag', {
            body: serialize(data, {indices: true}),
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + getCookie(TOKEN_CONGDONG)
            })
        });
        if (res.status == 200) {
            toast.info('Tag sản phẩm thành công');
            setDisplayModalTag(false);
            fetchMyImageById(imageTag.id);
            settaggedProduct([]);
        }

        if (res.status != 200) {
            const json = await res.json();
            if (!json.errors) {
                toast.error('Đã có lỗi xảy ra, vui lòng thử lại.');
                return;
            }
            const errors = json.errors;
            toast.error(errors || 'Đã có lỗi xảy ra, vui lòng thử lại.');
        }
    };

    return <Modal show={displayModalTag} onHide={() => setDisplayModalTag(false)} role="document" className="modal-photo-posts">
        <div className="wrap">
            <div className="closeBtn">
                <button type="button" className="close" onClick={() => setDisplayModalTag(false)} data-dismiss="modal" aria-label="Close">
                    <img src="/images/icon-close.png" alt="" />
                </button>
                <div className="photoPosts-flex">
                    <div className="photoPosts-thumb">
                        <div className="photoPostsShow">
                            {!isEmpty(imageTag) &&
                                <div className="photo-thumb sliderPhoto" style={{ position: 'relative' }}>
                                    <div className="photo-img">
                                        <img src={imageTag.storage_url} alt=""
                                            onClick={clickTag}
                                            ref={imgElement}
                                        />
                                        {imageTag['tagged_products'].map((tag, index) => {
                                            if (isEmpty(tag.position)) return <></>;
                                            return <TagImage key={`${imageTag.id}` + index} tag={tag} tagShowingId={tagShowingId} setTagShowingId={setTagShowingId} />;
                                        })}
                                    </div>
                                    {
                                        taggedProduct.map((item, index) => {
                                            // console.log(item);
                                            return <Tag key={index} location={item.location} sku={`${item.product.sku}`} />;
                                        })
                                    }
                                    <Tag location={location} />
                                </div>
                            }
                        </div>
                        <button className="btn btn--blue mt-2" onClick={submitTag}>Hoàn thành tag sản phẩm</button>
                        <div className="photoPosts-note">
                            <div className="photoPosts-note-item"><img className="svg" src="/images/icon-bulb.svg" alt="" /></div>
                            <ul className="photoPosts-note-text">
                                <li>Bấm chọn vị trí trên ảnh để tag sản phẩm.</li>
                                <li>Mỗi tag sản phẩm được duyệt, bạn sẽ được nhận 50 điểm thưởng</li>
                            </ul>
                        </div>
                        <div className="listSearch mt-3">
                            <ul>
                                {taggedProduct.map((item, index) => <ProductDetail key={index} item={item.product} isRemove={true} setTag={removeTag} />)}
                            </ul>
                        </div>
                    </div>

                    <ProductSearch setTag={assignTag}></ProductSearch>
                </div>
            </div>
        </div>
    </Modal>;
}
